<a
  class="company-signature"
  [ngClass]="{ dark: dark }"
  href="https://marlin.com.br"
  target="_blank"
>
  &#64;2024 - eNOSS Desenvolvido por Marlin - v{{ version }}
</a>
